import React from 'react';

const SkylineClouds = ({ stroke }) => (
  <>
    <g className="cs-cloud-rev" stroke={stroke} strokeWidth="0.9" strokeOpacity="0.32" fill="none">
      <path d="M 100 60 q 14 -10 28 -2 q 12 -10 24 0 q 14 -6 20 4 q 14 0 10 10 q -40 6 -82 0 q -14 -4 0 -12 z" />
      <path d="M 940 38 q 18 -12 36 -2 q 16 -12 30 0 q 18 -8 26 4 q 18 0 12 12 q -50 8 -104 0 q -18 -4 0 -14 z" />
    </g>
    <g className="cs-cloud" stroke={stroke} strokeWidth="0.9" strokeOpacity="0.45" fill="none" style={{ animationDelay: '6s' }}>
      <path d="M 380 25 q 18 -12 36 -2 q 16 -12 30 0 q 18 -8 26 4 q 18 0 12 12 q -50 8 -104 0 q -18 -4 0 -14 z" />
      <path d="M 1260 50 q 14 -10 28 -2 q 12 -10 24 0 q 14 -6 20 4 q 14 0 10 10 q -40 6 -82 0 q -14 -4 0 -12 z" />
    </g>
  </>
);

export default SkylineClouds;
